import React from 'react';
import * as S from './styles';
import { KenloSignatureTextIcon, MailCircleSignature } from 'components/Icons';
import { Close } from 'styled-icons/ionicons-outline';
import { Line } from 'components/Line';
import { ErrorCircle } from 'styled-icons/fluentui-system-filled';
import { Modal } from 'components/Modal/Modal';
import { api } from 'services/api';

interface IWaitingPayment {
  closeDrawer: () => void;
  cases: any
}

// Função para formatar data do formato "2023-07-10" para "15 de julho"
const formatDateToPortuguese = (dateString: string) => {
  try {
    const date = new Date(dateString);
    
    // Verifica se a data é válida
    if (isNaN(date.getTime())) {
      return 'data inválida';
    }

    const day = date.getDate();
    const month = date.toLocaleDateString('pt-BR', { month: 'long' });
    
    return `${day} de ${month}`;
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return 'data inválida';
  }
};

const WaitingPayment = ({ closeDrawer, cases }: IWaitingPayment) => {
  const [isOepnModal, setIsOpenModal] = React.useState(false);
  const getTitle = () => {
    if (cases.compo_billings.length) {
      if (cases.compo_billings[0].billing.status === "paga") {
        return "Pagamento em processamento"
      }
      return "Aguardando pagamento"
    }
    return "Pedido recebido com sucesso"
  }
  const getDescription = () => {
    if (cases.compo_billings.length) {
      if (cases.compo_billings[0].billing.status === "paga") {
        return "Recebemos o pagamento e já estamos configurando seu plano. Em breve, os envelopes contratados estarão disponíveis."
      }
      return "O plano selecionado está aguardando o pagamento. Você pode baixar o boleto agora ou acessá-lo pela seção de faturas."
    }
    return "Estamos gerando seu boleto. Em até 2 horas, ele ficará disponível nesta tela ou na seção de faturas.";
  }
 const getMessageFooter = ()=> {
  if (cases.compo_billings.length) {
    if (cases.compo_billings[0].billing.status !== "paga") {
      const dueDate = cases.compo_billings[0].billing.dueDate;
      const formattedDate = formatDateToPortuguese(dueDate);
      
      return    (
          <S.Subtitle>
            O boleto vence em <S.SubtitleBold>{formattedDate}.</S.SubtitleBold> Se
            mudar de ideia, é possível{' '}
            <S.TextInfos
              lineWeight="500"
              color="#F82E52"
              cursor
              onClick={() => setIsOpenModal(true)}
            >
              cancelar
            </S.TextInfos>{' '}
            a contratação. Após o pagamento, os créditos podem levar até 2 dias
            para serem liberados.
          </S.Subtitle>
        )
    }
    return;
  }
  return <S.Subtitle>
 Se
  mudar de ideia, é possível{' '}
  <S.TextInfos
    lineWeight="500"
    color="#F82E52"
    onClick={() => setIsOpenModal(true)}
  >
    cancelar
  </S.TextInfos>{' '}
  a contratação.
</S.Subtitle>
 }
 const CancelCase = async () => {
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  try {
    await api.delete(
      `/case/${cases.id_case}`,
      {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      },
    );
    closeDrawer();
  } catch (error) {
    console.log(error);
  }
 }
  return (
    <>
      <S.Header>
        <S.Infos>
          <S.Profile>
            <KenloSignatureTextIcon />
          </S.Profile>

          <S.Close onClick={closeDrawer}>
            <Close size={24} />
          </S.Close>
        </S.Infos>
      </S.Header>
      <S.Main>
        <S.Value>
          <ErrorCircle
            color={cases.compo_billings[0].billing.status !== "paga" ? "#DA9227" : "#808080"}
            size={24}
            style={{ marginRight: '16px' }}
          />{' '}
          {getTitle()}
        </S.Value>
        <S.Subtitle>
          {getDescription()}
        </S.Subtitle>
        <S.Box>
          <S.BoxContent>
          <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <S.SubtitleBold>Plano selecionado</S.SubtitleBold>
              {cases.compo_billings[0].billing.status !== "paga" && 
              <S.Subtitle>
              <S.SubtitleBold cursor style={{color: cases.compo_billings[0].billing.downladUrl ? '#F82E52' : "#B8B8B8" }}
               onClick={()=>  window.open(`${cases.compo_billings[0].billing.downladUrl}`, '_blank')
              }>&nbsp;&nbsp;Ver boleto</S.SubtitleBold>
            </S.Subtitle>}
            </div>
         
            <div
              style={{
                display: 'flex',
                alignContent:"center",
                alignItems:"center",
                gap: "8px",
              }}
            >
              <MailCircleSignature />
              <S.SubtitleBold>{cases?.case_products[0]?.amount} Envelopes adicionais</S.SubtitleBold>
            </div>

      
            {cases.compo_billings.length && <>
              <Line width="100%" border="0.1rem" />

              <S.BoxFooter>
                <S.ContentFooter></S.ContentFooter>
                <S.ContentFooter>
                  {' '}
                  <S.TitleValue>Pagamento no boleto</S.TitleValue>
                  <S.Value>R$ {cases.compo_billings[0].value} </S.Value>
                </S.ContentFooter>
              </S.BoxFooter>
            </>}

          </S.BoxContent>
        </S.Box>
        {getMessageFooter()}
      </S.Main>
      {isOepnModal && (
        <Modal
          isOpen={isOepnModal}
          onClose={() => setIsOpenModal(false)}
          title="Cancelar contratação"
          closeText="Manter plano"
          successText="Cancelar"
          onSuccess={() => {
            CancelCase()
          }}
        >
          <S.TextInfos lineWeight="500">
            Ao cancelar, o boleto será invalidado e os envelopes do plano não
            serão liberados. Se mudar de ideia, você poderá contratar novamente.
          </S.TextInfos>
        </Modal>
      )}
    </>
  );
};
export default WaitingPayment;
